
const ListIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px"
		 fill="#5f6368">
		<path
			d="M297.95-607.44v-50.25H820v50.25H297.95Zm0 152.57v-50.26H820v50.26H297.95Zm0 152.56v-50.25H820v50.25H297.95ZM167.43-605.13q-11.16 0-19.29-8.11-8.14-8.12-8.14-19.91 0-11.47 8.14-19.16 8.14-7.69 19.63-7.69 11.5 0 19.3 7.78 7.8 7.78 7.8 19.27 0 11.59-7.89 19.71-7.89 8.11-19.55 8.11Zm0 152.18q-11.16 0-19.29-8.03Q140-469 140-480.33q0-11.82 8.14-19.66 8.14-7.83 19.63-7.83 11.5 0 19.3 7.92 7.8 7.91 7.8 20.03 0 10.87-7.89 18.9-7.89 8.02-19.55 8.02Zm0 152.95q-11.16 0-19.29-8.12-8.14-8.12-8.14-19.91 0-11.46 8.14-19.15 8.14-7.69 19.63-7.69 11.5 0 19.3 7.77 7.8 7.78 7.8 19.28 0 11.58-7.89 19.7T167.43-300Z"/>
	</svg>
);

export default ListIcon;
